export default "__VITE_ASSET__BKIqTiH1__"